function formatMinutes(minutes) {
  if (minutes == null || Number.isNaN(Number(minutes))) {
    return "—";
  }

  const value = Number(minutes);

  if (value < 60) {
    return `${value}m ago`;
  }

  const hours = Math.floor(value / 60);
  const remainder = value % 60;
  return remainder ? `${hours}h ${remainder}m ago` : `${hours}h ago`;
}

const WeatherFreshnessLabel = ({ freshnessMinutes, expectedRefreshMinutes, healthStatus }) => {
  if (healthStatus === "historical") {
    return <span className="weather-freshness-label weather-freshness-label--archive">Archive</span>;
  }

  if (healthStatus === "disabled") {
    return <span className="weather-freshness-label">Disabled</span>;
  }

  if (freshnessMinutes == null) {
    return <span className="weather-freshness-label">No freshness data</span>;
  }

  const isStale =
    expectedRefreshMinutes != null && Number(freshnessMinutes) > Number(expectedRefreshMinutes);

  return (
    <span
      className={`weather-freshness-label${
        isStale ? " weather-freshness-label--stale" : " weather-freshness-label--fresh"
      }`}
    >
      {formatMinutes(freshnessMinutes)}
      {expectedRefreshMinutes != null ? ` (expected ≤${expectedRefreshMinutes}m)` : ""}
    </span>
  );
};

export default WeatherFreshnessLabel;
